const map = {
	"./MLK_Tire_Logo.png": 51552,
	"./QuiclkLogo.png": 37643,
	"./animations/loading.gif": 20708,
	"./aplus-auto-logo.png": 84506,
	"./auth-one-bg.jpg": 68776,
	"./bg-d.png": 92677,
	"./brands/bitbucket.png": 22287,
	"./brands/dribbble.png": 51924,
	"./brands/dropbox.png": 47138,
	"./brands/github.png": 95839,
	"./brands/mail_chimp.png": 77795,
	"./brands/slack.png": 17680,
	"./carsmartt.jpg": 12576,
	"./clients/amazon.svg": 67742,
	"./clients/lenovo.svg": 51475,
	"./clients/paypal.svg": 77611,
	"./clients/shopify.svg": 19408,
	"./clients/verizon.svg": 70391,
	"./clients/walmart.svg": 90590,
	"./comingsoon.png": 78491,
	"./companies/img-1.png": 46244,
	"./companies/img-2.png": 83103,
	"./companies/img-3.png": 86166,
	"./companies/img-4.png": 26249,
	"./companies/img-5.png": 31776,
	"./companies/img-6.png": 10107,
	"./companies/img-7.png": 95282,
	"./companies/img-8.png": 66133,
	"./demos/creative.png": 28495,
	"./demos/default.png": 81213,
	"./demos/interactive.png": 72710,
	"./demos/material.png": 24855,
	"./demos/minimal.png": 7047,
	"./demos/modern.png": 47305,
	"./demos/saas.png": 31300,
	"./error.svg": 73693,
	"./error400-cover.png": 91327,
	"./error500.png": 72080,
	"./faq-img.png": 11225,
	"./flags/china.svg": 93558,
	"./flags/french.svg": 45841,
	"./flags/germany.svg": 21148,
	"./flags/italy.svg": 59506,
	"./flags/russia.svg": 51186,
	"./flags/spain.svg": 63080,
	"./flags/us.svg": 16761,
	"./giftbox.png": 48186,
	"./icons/cars.png": 84763,
	"./icons/change-password.png": 30130,
	"./icons/clients.png": 31316,
	"./icons/home.png": 41795,
	"./icons/oil.png": 39232,
	"./icons/permissions.png": 21924,
	"./icons/power.png": 27743,
	"./icons/profile.png": 60767,
	"./icons/receipt.png": 79644,
	"./icons/reports.png": 81197,
	"./icons/roles.png": 31783,
	"./icons/services.png": 16630,
	"./icons/teams.png": 30794,
	"./icons/tire.png": 21820,
	"./illustrator-1.png": 3458,
	"./landing/features/img-1.png": 22384,
	"./landing/features/img-2.png": 87787,
	"./landing/features/img-3.png": 24130,
	"./landing/img-pattern.png": 4987,
	"./landing/process-arrow-img.png": 7918,
	"./login.jpg": 52408,
	"./logo-dark.png": 76317,
	"./logo-light.png": 90853,
	"./logo-sm.png": 91929,
	"./mac-img.png": 2976,
	"./maintenance.png": 77302,
	"./modals/login.png": 53539,
	"./modals/signup.png": 22186,
	"./modals/subscribe.png": 47596,
	"./modals/success-payment.png": 25444,
	"./nft/add.png": 5791,
	"./nft/bg-pattern.png": 38732,
	"./nft/img-01.jpg": 82883,
	"./nft/img-02.jpg": 4756,
	"./nft/img-03.jpg": 2129,
	"./nft/img-04.jpg": 12898,
	"./nft/img-05.jpg": 25567,
	"./nft/img-06.jpg": 41232,
	"./nft/money.png": 66478,
	"./nft/sell.png": 1148,
	"./nft/wallet.png": 7815,
	"./nft/wallet/alpha.png": 60942,
	"./nft/wallet/binance.png": 33724,
	"./nft/wallet/coinbase.png": 51892,
	"./nft/wallet/enjin.png": 95298,
	"./nft/wallet/kukai.png": 38671,
	"./nft/wallet/math.png": 52466,
	"./nft/wallet/metamask.png": 67071,
	"./products/img-1.png": 61805,
	"./products/img-10.png": 43417,
	"./products/img-2.png": 47830,
	"./products/img-3.png": 61119,
	"./products/img-4.png": 9792,
	"./products/img-5.png": 87913,
	"./products/img-6.png": 56946,
	"./products/img-7.png": 88123,
	"./products/img-8.png": 91884,
	"./profile-bg.jpg": 69822,
	"./sidebar/img-1.jpg": 91093,
	"./sidebar/img-2.jpg": 81194,
	"./sidebar/img-3.jpg": 37031,
	"./sidebar/img-4.jpg": 31036,
	"./small/img-1.jpg": 15776,
	"./small/img-10.jpg": 67962,
	"./small/img-11.jpg": 62423,
	"./small/img-12.jpg": 28200,
	"./small/img-2.jpg": 29391,
	"./small/img-3.jpg": 57010,
	"./small/img-4.jpg": 82497,
	"./small/img-5.jpg": 4452,
	"./small/img-6.jpg": 98611,
	"./small/img-7.jpg": 12150,
	"./small/img-8.jpg": 37637,
	"./small/img-9.jpg": 94120,
	"./svg/bell.svg": 99951,
	"./svg/crypto-icons/$pac.svg": 56585,
	"./svg/crypto-icons/0xbtc.svg": 43662,
	"./svg/crypto-icons/2give.svg": 41030,
	"./svg/crypto-icons/aave.svg": 68292,
	"./svg/crypto-icons/abt.svg": 90600,
	"./svg/crypto-icons/act.svg": 94251,
	"./svg/crypto-icons/actn.svg": 56263,
	"./svg/crypto-icons/ada.svg": 56703,
	"./svg/crypto-icons/add.svg": 96514,
	"./svg/crypto-icons/adx.svg": 96694,
	"./svg/crypto-icons/ae.svg": 64275,
	"./svg/crypto-icons/aeon.svg": 68740,
	"./svg/crypto-icons/aeur.svg": 74622,
	"./svg/crypto-icons/agi.svg": 65066,
	"./svg/crypto-icons/agrs.svg": 16800,
	"./svg/crypto-icons/aion.svg": 36648,
	"./svg/crypto-icons/algo.svg": 88316,
	"./svg/crypto-icons/amb.svg": 38691,
	"./svg/crypto-icons/amp.svg": 59217,
	"./svg/crypto-icons/ampl.svg": 91847,
	"./svg/crypto-icons/ankr.svg": 90779,
	"./svg/crypto-icons/ant.svg": 32772,
	"./svg/crypto-icons/apex.svg": 18389,
	"./svg/crypto-icons/appc.svg": 13501,
	"./svg/crypto-icons/ardr.svg": 21482,
	"./svg/crypto-icons/arg.svg": 28155,
	"./svg/crypto-icons/ark.svg": 4943,
	"./svg/crypto-icons/arn.svg": 20530,
	"./svg/crypto-icons/arnx.svg": 84838,
	"./svg/crypto-icons/ary.svg": 53965,
	"./svg/crypto-icons/ast.svg": 22683,
	"./svg/crypto-icons/atm.svg": 22011,
	"./svg/crypto-icons/atom.svg": 24318,
	"./svg/crypto-icons/audr.svg": 15053,
	"./svg/crypto-icons/auto.svg": 11672,
	"./svg/crypto-icons/aywa.svg": 52023,
	"./svg/crypto-icons/bab.svg": 16636,
	"./svg/crypto-icons/bal.svg": 50058,
	"./svg/crypto-icons/band.svg": 7236,
	"./svg/crypto-icons/bat.svg": 58690,
	"./svg/crypto-icons/bay.svg": 53591,
	"./svg/crypto-icons/bcbc.svg": 78269,
	"./svg/crypto-icons/bcc.svg": 4515,
	"./svg/crypto-icons/bcd.svg": 46236,
	"./svg/crypto-icons/bch.svg": 16136,
	"./svg/crypto-icons/bcio.svg": 40060,
	"./svg/crypto-icons/bcn.svg": 48822,
	"./svg/crypto-icons/bco.svg": 35943,
	"./svg/crypto-icons/bcpt.svg": 94620,
	"./svg/crypto-icons/bdl.svg": 14393,
	"./svg/crypto-icons/beam.svg": 22012,
	"./svg/crypto-icons/bela.svg": 81483,
	"./svg/crypto-icons/bix.svg": 18398,
	"./svg/crypto-icons/blcn.svg": 78412,
	"./svg/crypto-icons/blk.svg": 37326,
	"./svg/crypto-icons/block.svg": 69404,
	"./svg/crypto-icons/blz.svg": 52047,
	"./svg/crypto-icons/bnb.svg": 7981,
	"./svg/crypto-icons/bnt.svg": 37603,
	"./svg/crypto-icons/bnty.svg": 18928,
	"./svg/crypto-icons/booty.svg": 92190,
	"./svg/crypto-icons/bos.svg": 5439,
	"./svg/crypto-icons/bpt.svg": 62309,
	"./svg/crypto-icons/bq.svg": 82146,
	"./svg/crypto-icons/brd.svg": 99087,
	"./svg/crypto-icons/bsd.svg": 65068,
	"./svg/crypto-icons/bsv.svg": 88926,
	"./svg/crypto-icons/btc.svg": 96494,
	"./svg/crypto-icons/btcd.svg": 20158,
	"./svg/crypto-icons/btch.svg": 63978,
	"./svg/crypto-icons/btcp.svg": 22466,
	"./svg/crypto-icons/btcz.svg": 72440,
	"./svg/crypto-icons/btdx.svg": 63051,
	"./svg/crypto-icons/btg.svg": 81570,
	"./svg/crypto-icons/btm.svg": 31544,
	"./svg/crypto-icons/bts.svg": 79262,
	"./svg/crypto-icons/btt.svg": 39169,
	"./svg/crypto-icons/btx.svg": 94709,
	"./svg/crypto-icons/burst.svg": 43765,
	"./svg/crypto-icons/bze.svg": 5926,
	"./svg/crypto-icons/call.svg": 67697,
	"./svg/crypto-icons/cc.svg": 39731,
	"./svg/crypto-icons/cdn.svg": 12354,
	"./svg/crypto-icons/cdt.svg": 40648,
	"./svg/crypto-icons/cenz.svg": 72409,
	"./svg/crypto-icons/chain.svg": 3816,
	"./svg/crypto-icons/chat.svg": 79287,
	"./svg/crypto-icons/chips.svg": 92266,
	"./svg/crypto-icons/chsb.svg": 61859,
	"./svg/crypto-icons/cix.svg": 48515,
	"./svg/crypto-icons/clam.svg": 8114,
	"./svg/crypto-icons/cloak.svg": 1691,
	"./svg/crypto-icons/cmm.svg": 70794,
	"./svg/crypto-icons/cmt.svg": 59859,
	"./svg/crypto-icons/cnd.svg": 88486,
	"./svg/crypto-icons/cnx.svg": 82098,
	"./svg/crypto-icons/cny.svg": 31491,
	"./svg/crypto-icons/cob.svg": 93543,
	"./svg/crypto-icons/colx.svg": 35707,
	"./svg/crypto-icons/comp.svg": 81184,
	"./svg/crypto-icons/coqui.svg": 57338,
	"./svg/crypto-icons/cred.svg": 38949,
	"./svg/crypto-icons/crpt.svg": 30062,
	"./svg/crypto-icons/crv.svg": 35744,
	"./svg/crypto-icons/crw.svg": 50129,
	"./svg/crypto-icons/cs.svg": 34403,
	"./svg/crypto-icons/ctr.svg": 67238,
	"./svg/crypto-icons/ctxc.svg": 90295,
	"./svg/crypto-icons/cvc.svg": 48209,
	"./svg/crypto-icons/d.svg": 89247,
	"./svg/crypto-icons/dai.svg": 78989,
	"./svg/crypto-icons/dash.svg": 22541,
	"./svg/crypto-icons/dat.svg": 95112,
	"./svg/crypto-icons/data.svg": 39817,
	"./svg/crypto-icons/dbc.svg": 68942,
	"./svg/crypto-icons/dcn.svg": 69172,
	"./svg/crypto-icons/dcr.svg": 86880,
	"./svg/crypto-icons/deez.svg": 53645,
	"./svg/crypto-icons/dent.svg": 70998,
	"./svg/crypto-icons/dew.svg": 23951,
	"./svg/crypto-icons/dgb.svg": 86956,
	"./svg/crypto-icons/dgd.svg": 8354,
	"./svg/crypto-icons/dlt.svg": 18055,
	"./svg/crypto-icons/dnt.svg": 69325,
	"./svg/crypto-icons/dock.svg": 74084,
	"./svg/crypto-icons/doge.svg": 37174,
	"./svg/crypto-icons/dot.svg": 29818,
	"./svg/crypto-icons/drgn.svg": 59336,
	"./svg/crypto-icons/drop.svg": 93238,
	"./svg/crypto-icons/dta.svg": 83554,
	"./svg/crypto-icons/dth.svg": 91595,
	"./svg/crypto-icons/dtr.svg": 41153,
	"./svg/crypto-icons/ebst.svg": 69285,
	"./svg/crypto-icons/eca.svg": 79874,
	"./svg/crypto-icons/edg.svg": 51181,
	"./svg/crypto-icons/edo.svg": 44005,
	"./svg/crypto-icons/edoge.svg": 29565,
	"./svg/crypto-icons/ela.svg": 46939,
	"./svg/crypto-icons/elec.svg": 64550,
	"./svg/crypto-icons/elf.svg": 31668,
	"./svg/crypto-icons/elix.svg": 18401,
	"./svg/crypto-icons/ella.svg": 87379,
	"./svg/crypto-icons/emb.svg": 27767,
	"./svg/crypto-icons/emc.svg": 56582,
	"./svg/crypto-icons/emc2.svg": 8136,
	"./svg/crypto-icons/eng.svg": 64163,
	"./svg/crypto-icons/enj.svg": 31766,
	"./svg/crypto-icons/entrp.svg": 42606,
	"./svg/crypto-icons/eon.svg": 41353,
	"./svg/crypto-icons/eop.svg": 92495,
	"./svg/crypto-icons/eos.svg": 13468,
	"./svg/crypto-icons/eqli.svg": 47886,
	"./svg/crypto-icons/equa.svg": 92973,
	"./svg/crypto-icons/etc.svg": 46497,
	"./svg/crypto-icons/eth.svg": 80266,
	"./svg/crypto-icons/ethos.svg": 78976,
	"./svg/crypto-icons/etn.svg": 71380,
	"./svg/crypto-icons/etp.svg": 88898,
	"./svg/crypto-icons/eur.svg": 1999,
	"./svg/crypto-icons/evx.svg": 76444,
	"./svg/crypto-icons/exmo.svg": 10702,
	"./svg/crypto-icons/exp.svg": 22278,
	"./svg/crypto-icons/fair.svg": 77915,
	"./svg/crypto-icons/fct.svg": 93472,
	"./svg/crypto-icons/fil.svg": 87046,
	"./svg/crypto-icons/fjc.svg": 868,
	"./svg/crypto-icons/fldc.svg": 85308,
	"./svg/crypto-icons/flo.svg": 63854,
	"./svg/crypto-icons/flux.svg": 71300,
	"./svg/crypto-icons/fsn.svg": 11514,
	"./svg/crypto-icons/ftc.svg": 6738,
	"./svg/crypto-icons/fuel.svg": 96773,
	"./svg/crypto-icons/fun.svg": 22128,
	"./svg/crypto-icons/game.svg": 1579,
	"./svg/crypto-icons/gas.svg": 4844,
	"./svg/crypto-icons/gbp.svg": 95786,
	"./svg/crypto-icons/gbx.svg": 56978,
	"./svg/crypto-icons/gbyte.svg": 4706,
	"./svg/crypto-icons/generic.svg": 64140,
	"./svg/crypto-icons/gin.svg": 80065,
	"./svg/crypto-icons/glxt.svg": 32180,
	"./svg/crypto-icons/gmr.svg": 28433,
	"./svg/crypto-icons/gno.svg": 27401,
	"./svg/crypto-icons/gnt.svg": 60946,
	"./svg/crypto-icons/gold.svg": 85291,
	"./svg/crypto-icons/grc.svg": 60921,
	"./svg/crypto-icons/grin.svg": 18079,
	"./svg/crypto-icons/grs.svg": 88745,
	"./svg/crypto-icons/grt.svg": 59302,
	"./svg/crypto-icons/gsc.svg": 87238,
	"./svg/crypto-icons/gto.svg": 51167,
	"./svg/crypto-icons/gup.svg": 51051,
	"./svg/crypto-icons/gusd.svg": 88756,
	"./svg/crypto-icons/gvt.svg": 6058,
	"./svg/crypto-icons/gxs.svg": 67447,
	"./svg/crypto-icons/gzr.svg": 41968,
	"./svg/crypto-icons/hight.svg": 43291,
	"./svg/crypto-icons/hns.svg": 26934,
	"./svg/crypto-icons/hodl.svg": 15966,
	"./svg/crypto-icons/hot.svg": 97414,
	"./svg/crypto-icons/hpb.svg": 67041,
	"./svg/crypto-icons/hsr.svg": 43516,
	"./svg/crypto-icons/ht.svg": 43373,
	"./svg/crypto-icons/html.svg": 13130,
	"./svg/crypto-icons/huc.svg": 58039,
	"./svg/crypto-icons/husd.svg": 16105,
	"./svg/crypto-icons/hush.svg": 34669,
	"./svg/crypto-icons/icn.svg": 89385,
	"./svg/crypto-icons/icp.svg": 74319,
	"./svg/crypto-icons/icx.svg": 61095,
	"./svg/crypto-icons/ignis.svg": 23985,
	"./svg/crypto-icons/ilk.svg": 88629,
	"./svg/crypto-icons/ink.svg": 41147,
	"./svg/crypto-icons/ins.svg": 84691,
	"./svg/crypto-icons/ion.svg": 46373,
	"./svg/crypto-icons/iop.svg": 85219,
	"./svg/crypto-icons/iost.svg": 66188,
	"./svg/crypto-icons/iotx.svg": 56741,
	"./svg/crypto-icons/iq.svg": 16663,
	"./svg/crypto-icons/itc.svg": 58677,
	"./svg/crypto-icons/jnt.svg": 32363,
	"./svg/crypto-icons/jpy.svg": 22184,
	"./svg/crypto-icons/kcs.svg": 18962,
	"./svg/crypto-icons/kin.svg": 70565,
	"./svg/crypto-icons/klown.svg": 84188,
	"./svg/crypto-icons/kmd.svg": 89163,
	"./svg/crypto-icons/knc.svg": 51985,
	"./svg/crypto-icons/krb.svg": 59796,
	"./svg/crypto-icons/ksm.svg": 88948,
	"./svg/crypto-icons/lbc.svg": 57574,
	"./svg/crypto-icons/lend.svg": 34014,
	"./svg/crypto-icons/leo.svg": 37855,
	"./svg/crypto-icons/link.svg": 49717,
	"./svg/crypto-icons/lkk.svg": 17833,
	"./svg/crypto-icons/loom.svg": 96350,
	"./svg/crypto-icons/lpt.svg": 1747,
	"./svg/crypto-icons/lrc.svg": 95894,
	"./svg/crypto-icons/lsk.svg": 28529,
	"./svg/crypto-icons/ltc.svg": 49880,
	"./svg/crypto-icons/lun.svg": 3070,
	"./svg/crypto-icons/maid.svg": 4036,
	"./svg/crypto-icons/mana.svg": 94372,
	"./svg/crypto-icons/matic.svg": 35793,
	"./svg/crypto-icons/max.svg": 37897,
	"./svg/crypto-icons/mcap.svg": 29254,
	"./svg/crypto-icons/mco.svg": 31756,
	"./svg/crypto-icons/mda.svg": 71275,
	"./svg/crypto-icons/mds.svg": 66329,
	"./svg/crypto-icons/med.svg": 13913,
	"./svg/crypto-icons/meetone.svg": 63592,
	"./svg/crypto-icons/mft.svg": 26128,
	"./svg/crypto-icons/miota.svg": 11571,
	"./svg/crypto-icons/mith.svg": 50183,
	"./svg/crypto-icons/mkr.svg": 29777,
	"./svg/crypto-icons/mln.svg": 7284,
	"./svg/crypto-icons/mnx.svg": 46524,
	"./svg/crypto-icons/mnz.svg": 28798,
	"./svg/crypto-icons/moac.svg": 68249,
	"./svg/crypto-icons/mod.svg": 96347,
	"./svg/crypto-icons/mona.svg": 802,
	"./svg/crypto-icons/msr.svg": 34921,
	"./svg/crypto-icons/mth.svg": 57810,
	"./svg/crypto-icons/mtl.svg": 53918,
	"./svg/crypto-icons/music.svg": 86522,
	"./svg/crypto-icons/mzc.svg": 31427,
	"./svg/crypto-icons/nano.svg": 23435,
	"./svg/crypto-icons/nas.svg": 21249,
	"./svg/crypto-icons/nav.svg": 61244,
	"./svg/crypto-icons/ncash.svg": 66748,
	"./svg/crypto-icons/ndz.svg": 15971,
	"./svg/crypto-icons/nebl.svg": 98448,
	"./svg/crypto-icons/neo.svg": 89401,
	"./svg/crypto-icons/neos.svg": 51288,
	"./svg/crypto-icons/neu.svg": 28211,
	"./svg/crypto-icons/nexo.svg": 88365,
	"./svg/crypto-icons/ngc.svg": 46147,
	"./svg/crypto-icons/nio.svg": 27709,
	"./svg/crypto-icons/nkn.svg": 34890,
	"./svg/crypto-icons/nlc2.svg": 69660,
	"./svg/crypto-icons/nlg.svg": 76718,
	"./svg/crypto-icons/nmc.svg": 88133,
	"./svg/crypto-icons/nmr.svg": 49268,
	"./svg/crypto-icons/npxs.svg": 30972,
	"./svg/crypto-icons/ntbc.svg": 13026,
	"./svg/crypto-icons/nuls.svg": 51333,
	"./svg/crypto-icons/nxs.svg": 91558,
	"./svg/crypto-icons/nxt.svg": 21001,
	"./svg/crypto-icons/oax.svg": 17119,
	"./svg/crypto-icons/ok.svg": 58135,
	"./svg/crypto-icons/omg.svg": 5348,
	"./svg/crypto-icons/omni.svg": 77406,
	"./svg/crypto-icons/one.svg": 95963,
	"./svg/crypto-icons/ong.svg": 96345,
	"./svg/crypto-icons/ont.svg": 96026,
	"./svg/crypto-icons/oot.svg": 84237,
	"./svg/crypto-icons/ost.svg": 25969,
	"./svg/crypto-icons/ox.svg": 45716,
	"./svg/crypto-icons/oxt.svg": 21184,
	"./svg/crypto-icons/part.svg": 25306,
	"./svg/crypto-icons/pasc.svg": 5202,
	"./svg/crypto-icons/pasl.svg": 56757,
	"./svg/crypto-icons/pax.svg": 35872,
	"./svg/crypto-icons/paxg.svg": 28383,
	"./svg/crypto-icons/pay.svg": 71825,
	"./svg/crypto-icons/payx.svg": 11915,
	"./svg/crypto-icons/pink.svg": 32817,
	"./svg/crypto-icons/pirl.svg": 30570,
	"./svg/crypto-icons/pivx.svg": 2922,
	"./svg/crypto-icons/plr.svg": 101,
	"./svg/crypto-icons/poa.svg": 55331,
	"./svg/crypto-icons/poe.svg": 59727,
	"./svg/crypto-icons/polis.svg": 96170,
	"./svg/crypto-icons/poly.svg": 40211,
	"./svg/crypto-icons/pot.svg": 45006,
	"./svg/crypto-icons/powr.svg": 19365,
	"./svg/crypto-icons/ppc.svg": 44264,
	"./svg/crypto-icons/ppp.svg": 30955,
	"./svg/crypto-icons/ppt.svg": 95575,
	"./svg/crypto-icons/pre.svg": 98572,
	"./svg/crypto-icons/prl.svg": 88293,
	"./svg/crypto-icons/pungo.svg": 92972,
	"./svg/crypto-icons/pura.svg": 62819,
	"./svg/crypto-icons/qash.svg": 64906,
	"./svg/crypto-icons/qiwi.svg": 80831,
	"./svg/crypto-icons/qlc.svg": 14373,
	"./svg/crypto-icons/qrl.svg": 90944,
	"./svg/crypto-icons/qsp.svg": 43735,
	"./svg/crypto-icons/qtum.svg": 38828,
	"./svg/crypto-icons/r.svg": 86657,
	"./svg/crypto-icons/rads.svg": 23325,
	"./svg/crypto-icons/rap.svg": 51262,
	"./svg/crypto-icons/rcn.svg": 40230,
	"./svg/crypto-icons/rdd.svg": 81745,
	"./svg/crypto-icons/rdn.svg": 32683,
	"./svg/crypto-icons/ren.svg": 77972,
	"./svg/crypto-icons/rep.svg": 30114,
	"./svg/crypto-icons/repv2.svg": 82402,
	"./svg/crypto-icons/req.svg": 9107,
	"./svg/crypto-icons/rhoc.svg": 5785,
	"./svg/crypto-icons/ric.svg": 63541,
	"./svg/crypto-icons/rise.svg": 96466,
	"./svg/crypto-icons/rlc.svg": 62742,
	"./svg/crypto-icons/rpx.svg": 34593,
	"./svg/crypto-icons/rub.svg": 10496,
	"./svg/crypto-icons/rvn.svg": 62417,
	"./svg/crypto-icons/ryo.svg": 24433,
	"./svg/crypto-icons/safe.svg": 38602,
	"./svg/crypto-icons/safemoon.svg": 3801,
	"./svg/crypto-icons/sai.svg": 41370,
	"./svg/crypto-icons/salt.svg": 66601,
	"./svg/crypto-icons/san.svg": 18821,
	"./svg/crypto-icons/sand.svg": 41827,
	"./svg/crypto-icons/sbd.svg": 90610,
	"./svg/crypto-icons/sberbank.svg": 69209,
	"./svg/crypto-icons/sc.svg": 39619,
	"./svg/crypto-icons/shift.svg": 39579,
	"./svg/crypto-icons/sib.svg": 19577,
	"./svg/crypto-icons/sin.svg": 14877,
	"./svg/crypto-icons/skl.svg": 39557,
	"./svg/crypto-icons/sky.svg": 60296,
	"./svg/crypto-icons/slr.svg": 37518,
	"./svg/crypto-icons/sls.svg": 58623,
	"./svg/crypto-icons/smart.svg": 74780,
	"./svg/crypto-icons/sngls.svg": 85090,
	"./svg/crypto-icons/snm.svg": 10703,
	"./svg/crypto-icons/snt.svg": 40006,
	"./svg/crypto-icons/snx.svg": 50434,
	"./svg/crypto-icons/soc.svg": 77062,
	"./svg/crypto-icons/sol.svg": 75217,
	"./svg/crypto-icons/spacehbit.svg": 38704,
	"./svg/crypto-icons/spank.svg": 12548,
	"./svg/crypto-icons/sphtx.svg": 8468,
	"./svg/crypto-icons/srn.svg": 22712,
	"./svg/crypto-icons/stak.svg": 98132,
	"./svg/crypto-icons/start.svg": 58251,
	"./svg/crypto-icons/steem.svg": 67455,
	"./svg/crypto-icons/storj.svg": 79099,
	"./svg/crypto-icons/storm.svg": 47476,
	"./svg/crypto-icons/stox.svg": 49105,
	"./svg/crypto-icons/stq.svg": 80405,
	"./svg/crypto-icons/strat.svg": 41181,
	"./svg/crypto-icons/stx.svg": 70748,
	"./svg/crypto-icons/sub.svg": 27989,
	"./svg/crypto-icons/sumo.svg": 76089,
	"./svg/crypto-icons/sushi.svg": 93669,
	"./svg/crypto-icons/sys.svg": 7720,
	"./svg/crypto-icons/taas.svg": 5468,
	"./svg/crypto-icons/tau.svg": 68137,
	"./svg/crypto-icons/tbx.svg": 19557,
	"./svg/crypto-icons/tel.svg": 90356,
	"./svg/crypto-icons/ten.svg": 91702,
	"./svg/crypto-icons/tern.svg": 85560,
	"./svg/crypto-icons/tgch.svg": 70335,
	"./svg/crypto-icons/theta.svg": 2863,
	"./svg/crypto-icons/tix.svg": 70532,
	"./svg/crypto-icons/tkn.svg": 46492,
	"./svg/crypto-icons/tks.svg": 47529,
	"./svg/crypto-icons/tnb.svg": 61491,
	"./svg/crypto-icons/tnc.svg": 98850,
	"./svg/crypto-icons/tnt.svg": 82781,
	"./svg/crypto-icons/tomo.svg": 94014,
	"./svg/crypto-icons/tpay.svg": 20915,
	"./svg/crypto-icons/trig.svg": 20307,
	"./svg/crypto-icons/trtl.svg": 48375,
	"./svg/crypto-icons/trx.svg": 48917,
	"./svg/crypto-icons/tusd.svg": 88709,
	"./svg/crypto-icons/tzc.svg": 45590,
	"./svg/crypto-icons/ubq.svg": 74465,
	"./svg/crypto-icons/uma.svg": 95540,
	"./svg/crypto-icons/uni.svg": 73893,
	"./svg/crypto-icons/unity.svg": 81408,
	"./svg/crypto-icons/usd.svg": 96927,
	"./svg/crypto-icons/usdc.svg": 85102,
	"./svg/crypto-icons/usdt.svg": 27777,
	"./svg/crypto-icons/utk.svg": 43945,
	"./svg/crypto-icons/veri.svg": 84453,
	"./svg/crypto-icons/vet.svg": 6042,
	"./svg/crypto-icons/via.svg": 78531,
	"./svg/crypto-icons/vib.svg": 21488,
	"./svg/crypto-icons/vibe.svg": 78173,
	"./svg/crypto-icons/vivo.svg": 43059,
	"./svg/crypto-icons/vrc.svg": 93292,
	"./svg/crypto-icons/vrsc.svg": 45927,
	"./svg/crypto-icons/vtc.svg": 70018,
	"./svg/crypto-icons/vtho.svg": 94348,
	"./svg/crypto-icons/wabi.svg": 11326,
	"./svg/crypto-icons/wan.svg": 17577,
	"./svg/crypto-icons/waves.svg": 20337,
	"./svg/crypto-icons/wax.svg": 31815,
	"./svg/crypto-icons/wbtc.svg": 33289,
	"./svg/crypto-icons/wgr.svg": 92803,
	"./svg/crypto-icons/wicc.svg": 18879,
	"./svg/crypto-icons/wings.svg": 75639,
	"./svg/crypto-icons/wpr.svg": 48094,
	"./svg/crypto-icons/wtc.svg": 9947,
	"./svg/crypto-icons/x.svg": 89243,
	"./svg/crypto-icons/xas.svg": 59984,
	"./svg/crypto-icons/xbc.svg": 67690,
	"./svg/crypto-icons/xbp.svg": 86889,
	"./svg/crypto-icons/xby.svg": 12704,
	"./svg/crypto-icons/xcp.svg": 3134,
	"./svg/crypto-icons/xdn.svg": 4321,
	"./svg/crypto-icons/xem.svg": 56241,
	"./svg/crypto-icons/xin.svg": 47966,
	"./svg/crypto-icons/xlm.svg": 73930,
	"./svg/crypto-icons/xmcc.svg": 97230,
	"./svg/crypto-icons/xmg.svg": 99059,
	"./svg/crypto-icons/xmo.svg": 92043,
	"./svg/crypto-icons/xmr.svg": 58846,
	"./svg/crypto-icons/xmy.svg": 33205,
	"./svg/crypto-icons/xp.svg": 26657,
	"./svg/crypto-icons/xpa.svg": 32226,
	"./svg/crypto-icons/xpm.svg": 21798,
	"./svg/crypto-icons/xpr.svg": 89825,
	"./svg/crypto-icons/xrp.svg": 8057,
	"./svg/crypto-icons/xsg.svg": 37409,
	"./svg/crypto-icons/xtz.svg": 9501,
	"./svg/crypto-icons/xuc.svg": 63079,
	"./svg/crypto-icons/xvc.svg": 74142,
	"./svg/crypto-icons/xvg.svg": 94386,
	"./svg/crypto-icons/xzc.svg": 42466,
	"./svg/crypto-icons/yfi.svg": 67905,
	"./svg/crypto-icons/yoyow.svg": 46396,
	"./svg/crypto-icons/zcl.svg": 2828,
	"./svg/crypto-icons/zec.svg": 75257,
	"./svg/crypto-icons/zel.svg": 16382,
	"./svg/crypto-icons/zen.svg": 81084,
	"./svg/crypto-icons/zest.svg": 70439,
	"./svg/crypto-icons/zil.svg": 27754,
	"./svg/crypto-icons/zilla.svg": 34335,
	"./svg/crypto-icons/zrx.svg": 80259,
	"./sweetalert2/email-verify.png": 46350,
	"./sweetalert2/error-message.png": 64218,
	"./sweetalert2/join-community.png": 78400,
	"./sweetalert2/notification-message.png": 45483,
	"./sweetalert2/success-message.png": 33489,
	"./sweetalert2/warning-message.png": 69972,
	"./task.png": 10068,
	"./updatedHero.png": 98106,
	"./user-illustarator-1.png": 11773,
	"./user-illustarator-2.png": 14214,
	"./users/avatar-1.jpg": 5345,
	"./users/avatar-10.jpg": 24061,
	"./users/avatar-2.jpg": 29558,
	"./users/avatar-3.jpg": 57971,
	"./users/avatar-4.jpg": 67808,
	"./users/avatar-5.jpg": 35901,
	"./users/avatar-6.jpg": 81746,
	"./users/avatar-7.jpg": 58127,
	"./users/avatar-8.jpg": 66668,
	"./users/avatar-9.jpg": 64457,
	"./users/multi-user.jpg": 29845,
	"./users/user-dummy-img.jpg": 93212,
	"./verification-img.png": 64696
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89676;